'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentIdealAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14 7.87463V50.096C14 52.117 15.6465 53.7706 17.6589 53.7706H42.7775C61.7674 53.7706 70 43.0958 70 28.9302C70 14.838 61.7674 4.20001 42.7775 4.20001H17.6589C15.6465 4.20001 14 5.85359 14 7.87463Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M30.8128 14.5624V45.7599H44.3326C56.6083 45.7599 61.9321 38.7966 61.9321 28.9486C61.9321 19.5232 56.6083 12.2107 44.3326 12.2107H33.1545C31.8556 12.2107 30.8128 13.2763 30.8128 14.5624Z",
          fill: "#CC0066"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M42.7776 50.4084H20.9337C18.9945 50.4084 17.4211 48.8283 17.4211 46.8807V11.1083C17.4211 9.16077 18.9945 7.58069 20.9337 7.58069H42.7776C63.5055 7.58069 66.5972 20.9747 66.5972 28.9486C66.5972 42.7835 58.1268 50.4084 42.7776 50.4084ZM20.9337 8.75656C19.6348 8.75656 18.592 9.80383 18.592 11.1083V46.8807C18.592 48.1852 19.6348 49.2325 20.9337 49.2325H42.7776C57.3767 49.2325 65.4264 42.0303 65.4264 28.9486C65.4264 11.3839 51.2297 8.75656 42.7776 8.75656H20.9337Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.5694 24.7411C36.0451 24.7411 36.4841 24.8146 36.9049 24.9616C37.3257 25.1086 37.6733 25.3475 37.9843 25.6414C38.277 25.9537 38.5148 26.3396 38.6978 26.7805C38.8624 27.2399 38.9539 27.7727 38.9539 28.3974C38.9539 28.9486 38.8808 29.4446 38.7527 29.904C38.6063 30.3633 38.4051 30.7675 38.1307 31.0982C37.8563 31.4289 37.5086 31.6861 37.0879 31.8883C36.6671 32.072 36.1731 32.1822 35.606 32.1822H32.4044V24.7228H35.5694V24.7411ZM35.4597 30.8226C35.6975 30.8226 35.917 30.7859 36.1548 30.7124C36.3744 30.6389 36.5756 30.5103 36.7402 30.3265C36.9049 30.1428 37.0513 29.9223 37.161 29.6284C37.2708 29.3344 37.3257 29.0037 37.3257 28.5811C37.3257 28.2137 37.2891 27.8646 37.2159 27.5706C37.1427 27.2766 37.0147 27.001 36.85 26.7989C36.6854 26.5968 36.4658 26.4131 36.1914 26.3028C35.917 26.1926 35.5877 26.1375 35.1852 26.1375H34.0144V30.841H35.4597V30.8226Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M45.5583 24.7411V26.1191H41.6432V27.7176H45.2473V28.9853H41.6432V30.8042H45.6498V32.1822H40.015V24.7228H45.5583V24.7411Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M51.1565 24.7411L53.9373 32.2006H52.2359L51.6687 30.547H48.8879L48.3025 32.2006H46.656L49.4551 24.7411H51.1565ZM51.248 29.3161L50.3149 26.5784H50.2966L49.327 29.3161H51.248Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M56.59 24.7411V30.8227H60.2124V32.2006H54.9618V24.7411H56.59Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M24.7024 31.9067C26.5918 31.9067 28.1235 30.3685 28.1235 28.4709C28.1235 26.5734 26.5918 25.0352 24.7024 25.0352C22.813 25.0352 21.2813 26.5734 21.2813 28.4709C21.2813 30.3685 22.813 31.9067 24.7024 31.9067Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.2819 45.76C24.4097 45.76 22.1045 43.4266 22.1045 40.5604V36.5C22.1045 35.0668 23.2571 33.891 24.7024 33.891C26.1294 33.891 27.3002 35.0485 27.3002 36.5V45.76H27.2819Z",
          fill: "black"
        }
      )
    ]
  }
);
const VpPaymentIdealAsset = forwardRef(PaymentIdealAsset);

export { VpPaymentIdealAsset as default };
